<template>
  <fieldset class="step step-4">
    <Section :title="stepTitle">
      <CertificationFormGroup name="q_4_1">
        <TrueFalseControl
          id="q_4_1"
          v-model="form.q_4_1"
          number="1"
          label="Na chwilę składania wniosku dostępny jest szczegółowy program wydarzenia"
          label-description="uwzględniający wszystkie planowane aktywności w tym rozrywkowe"
          help="Szczegółowy program wydarzenia zawiera: jasny harmonogram bez luk w trakcie sesji naukowych, posiada jasno określone ramy czasowe, wskazuje prelegentów prowadzących poszczególne sesje"
          :disabled="formDisabled"
        />
      </CertificationFormGroup>

      <CertificationFormGroup
        v-if="form.q_4_1 && !formDisabled"
        name="files.programmeFull"
      >
        <template slot-scope="{ validator }">
          <InputFileControl
            id="programmeFull"
            v-model="form.files.programmeFull"
            label="Proszę załączyć program szczegółowy"
            number="2"
            description="Maksymalnie 20MB. Dozwolone pliki PDF, DOC, DOCX."
            :disabled="formDisabled"
            :inline="true"
            @input="touch(validator)"
          />
        </template>
      </CertificationFormGroup>
      <CertificationFormGroup v-if="programmeFull" name="files.programmeFull">
        <CustomControl
          id="programmeFull-dl"
          label="Załączony program szczegółowy"
          number="2a"
          :inline="true"
        >
          <Btn
            icon="download-alt"
            variant="outline-primary"
            :href="downloadUrl(programmeFull.file)"
            target="_blank"
            size="sm"
          >
            {{ programmeFull.filename }}
          </Btn>
        </CustomControl>
      </CertificationFormGroup>

      <CertificationFormGroup
        v-if="form.q_4_1 !== true && !formDisabled"
        name="files.programmeBrief"
      >
        <template slot-scope="{ validator }">
          <InputFileControl
            id="programmeBrief"
            v-model="form.files.programmeBrief"
            label="Proszę załączyć program ramowy"
            number="2"
            description="Maksymalnie 20MB. Dozwolone pliki PDF, DOC, DOCX."
            :disabled="formDisabled"
            :inline="true"
            @input="touch(validator)"
          />
        </template>
      </CertificationFormGroup>
      <CertificationFormGroup v-if="programmeBrief" name="files.programmeBrief">
        <CustomControl
          id="programmeBrief-dl"
          label="Załączony program ramowy"
          number="2a"
          :inline="true"
        >
          <Btn
            icon="download-alt"
            variant="outline-primary"
            :href="downloadUrl(programmeBrief.file)"
            target="_blank"
            size="sm"
          >
            {{ programmeBrief.filename }}
          </Btn>
        </CustomControl>
      </CertificationFormGroup>

      <CertificationFormGroup name="q_4_3">
        <TrueFalseControl
          id="q_4_3"
          v-model="form.q_4_3"
          number="3"
          label="Program merytoryczny trwa odpowiednio: co najmniej 3h dla wydarzeń trwających pół dnia i 6h dla wydarzeń całodniowych"
          :disabled="formDisabled"
        />
      </CertificationFormGroup>
      <CertificationFormGroup name="q_4_4">
        <TrueFalseControl
          id="q_4_4"
          v-model="form.q_4_4"
          number="4"
          label="Program merytoryczny zawiera również elementy wykraczające poza obszar terapeutyczny/diagnostyczny/praktykę medyczną"
          label-description="np. zawiera wystąpienia z zakresu zarządzania w ochronie zdrowia, zagadnienia prawne, zagadnienia związane z HTA, refundacją, umiejętności miękkie, etc."
          :disabled="formDisabled"
        />
      </CertificationFormGroup>
      <CertificationFormGroup name="q_4_5">
        <TrueFalseControl
          id="q_4_5"
          v-model="form.q_4_5"
          number="5"
          label="Organizator wydarzenia przewiduje/planuje obok programu merytorycznego również elementy pozamerytoryczne (rozrywkowe)"
          help="Elementy&nbsp;pozamerytoryczne/rozrywkowe, m.in: tańce lub takie wydarzenia, podczas których główną atrakcją jest muzyka na żywo, wycieczki krajoznawcze, spektakle teatralne, wydarzenia sportowe (np. narty, golf lub mecze piłki nożnej) i inne wydarzenia relaksacyjne. Dla uniknięcia wątpliwości, podkład muzyczny w tle nie stanowi Rozrywki."
          :disabled="formDisabled"
        />
      </CertificationFormGroup>
      <transition name="slide-fade">
        <div v-show="form.q_4_5">
          <CertificationFormGroup name="q_4_5a">
            <TrueFalseControl
              id="q_4_5a"
              v-model="form.q_4_5a"
              number="5a"
              label="Program pozamerytoryczny (rozrywkowy) pozostaje w konflikcie czasowym  z programem merytorycznym"
              :disabled="formDisabled"
            />
          </CertificationFormGroup>
          <CertificationFormGroup name="q_4_5b">
            <TrueFalseControl
              id="q_4_5b"
              v-model="form.q_4_5b"
              number="5b"
              label="Program pozamerytoryczny (rozrywkowy) dominuje nad programem merytorycznym"
              :disabled="formDisabled"
            />
          </CertificationFormGroup>
          <CertificationFormGroup name="q_4_5c">
            <TrueFalseControl
              id="q_4_5c"
              v-model="form.q_4_5c"
              number="5c"
              label="Przewidziana jest oddzielna opłata dla uczestników za udział w części pozamerytorycznej (rozrywkowej)"
              :disabled="formDisabled"
            />
          </CertificationFormGroup>
          <CertificationFormGroup name="q_4_5d">
            <TrueFalseControl
              id="q_4_5d"
              v-model="form.q_4_5d"
              number="5d"
              label="Organizator oświadcza i informuje w publicznie dostępnych materiałach dotyczących wydarzenia, że program pozamerytoryczny (rozrywkowy) nie zostanie sfinansowany ze środków pochodzących od firm członkowskich Izby POLMED lub MedTech Polska"
              :disabled="formDisabled"
            />
          </CertificationFormGroup>
        </div>
      </transition>
      <CertificationFormGroup name="q_4_6">
        <TrueFalseControl
          id="q_4_6"
          v-model="form.q_4_6"
          number="6"
          label="W trakcie wydarzenia przewidziane/planowane są wystąpienia sponsorowane/promocyjne firm"
          :disabled="formDisabled"
        />
      </CertificationFormGroup>
      <transition name="slide-fade">
        <div v-show="form.q_4_6">
          <CertificationFormGroup name="q_4_6a">
            <TrueFalseControl
              id="q_4_6a"
              v-model="form.q_4_6a"
              number="6a"
              label="Wystąpienia sponsorowane/promocyjne firm są/będą wyraźnie oznaczone w programie"
              :disabled="formDisabled"
            />
          </CertificationFormGroup>
        </div>
      </transition>
    </Section>
  </fieldset>
</template>

<script>
import BaseCertificationFormStep from "@/components/Base/Certification/BaseCertificationFormStep";
import TrueFalseControl from "@/components/Controls/TrueFalseControl";
import InputFileControl from "@/components/Controls/InputFileControl";
import CustomControl from "@/components/Controls/CustomControl";
import FileApi from "@/api/File";

export default {
  name: "CertificationFormStep4",
  components: {
    TrueFalseControl,
    InputFileControl,
    CustomControl
  },
  extends: BaseCertificationFormStep,
  computed: {
    programmeFull() {
      let programme = this.form.files.filter(item => item.type === "programme");
      return programme.length ? programme[0] : false;
    },
    programmeBrief() {
      let programme = this.form.files.filter(item => item.type === "brief");
      return programme.length ? programme[0] : false;
    }
  },
  methods: {
    downloadUrl(file) {
      return FileApi.getDownloadUrl(file);
    }
  }
};
</script>

<style scoped></style>
